<template>
	<div>
		<!-- <div id="tooltip"></div> -->
		<div>
			<canvas id="myChart" ref="myChart"></canvas>
			<div class="legendContainer">
				<div class="neighborhoodGraph" v-if="$store.state.neighborhoodName">
					<span class="square"></span> מחיר חציוני {{$store.state.neighborhoodName}}
				</div>
				<div class="settelmentGraph">
					<span class="square"></span>מחיר חציוני {{$store.state.settlementName}}
				</div>
				<div class="countryGraph">
					<span class="square"></span>מחיר חציוני ארצי
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Chart from "chart.js";

	Chart.defaults.global.legend.display = false;
	Chart.defaults.line.spanGaps = true;
	//scale
	Chart.defaults.scale.ticks.autoSkip = false;
	Chart.defaults.scale.ticks.padding = 8;
	Chart.defaults.scale.ticks.maxRotation = 0;
	Chart.defaults.scale.ticks.minRotation = 0;
	Chart.defaults.scale.ticks.beginAtZero = false;

	//gridLines
	Chart.defaults.scale.gridLines.drawOnChartArea = false;
	Chart.defaults.scale.gridLines.drawTicks = false;



	export default {
		name: "GraphComponent",
		data() {
			return {
				currentTab: "all",
				updateQueued: false,  // Add this line
				//pointIndex: undefined,
				base_level: null,
				tooltipEl: null,
				//myChart: null,
				//allData: [],
				//graphData: [],
				nameHere: "",
				typePage: "",
				minPrice: 0,
				maxPrice: 0,
				settlementId: null,
				neighborhoodId: null,
				settlementName: "",
				neighborhoodName: "",
				pageType: "",
				chartOptions: {
					maintainAspectRatio: true,  // Ensure aspect ratio is maintained
					aspectRatio: 2,  // Aspect ratio of 2:1
					interaction: {
						intersect: false,
						mode: "index",
					},
					spanGaps: true,
					legend: {
						display: false,
					},
					tooltips: {
						enabled: false, // Disable built-in tooltips
					},
					hover: {
						
						mode: "index", // Track mouse position across the chart
						intersect: false, // Do not require the mouse to be directly over a point
						onHover: (event, chartElement) => {
							if (chartElement && chartElement.length > 0) {
							var index = chartElement[0]._index;
							index = this.$store.state.graphData.length - 1 - index;
								
							this.$store.state.pointIndex = index;
							
							const label = this.$store.state.graphData[index].year + "/" + this.$store.state.graphData[index].month;
							const settlementPrice = this.$store.state.graphData[index].settlementPrice;
							const countryPrice = this.$store.state.graphData[index].countryPrice;
							const neighborhoodPrice = this.$store.state.graphData[index].neighborhoodPrice;
							
							this.updateTooltip(
								label,
								settlementPrice,
								countryPrice,
								neighborhoodPrice
							);
							
							if (!this.updateQueued) {
								this.updateQueued = true;
								requestAnimationFrame(() => {
							
							
								if (this.chart && typeof this.chart.update === 'function') {
									this.chart.update();
								}

								this.updateQueued = false;
								});
							}
							} else {
								this.$store.state.pointIndex = undefined;
							if (!this.updateQueued) {
								this.updateQueued = true;
								requestAnimationFrame(() => {
								if (this.chart && typeof this.chart.update === 'function') {
									this.chart.update();
								}
								this.updateQueued = false;
								});
							}
							}
						},
						},
					
					animation: {
						duration: 0 // Disable animations for smoother line updates
					},
					plugins: {
						customHoverLine: {
							afterDraw: (chart) => {
								const activeElements = chart.getActiveElements();
								if (activeElements && activeElements.length) {
									const ctx = chart.ctx;
									const yValue = this.$store.state.pointIndex;
									//const yValue = 3;
									const yScale = chart.scales.y;
									const yPos = yScale.getPixelForValue(yValue);
									
									ctx.save();
									ctx.beginPath();
									ctx.moveTo(chart.chartArea.left, yPos);
									ctx.lineTo(chart.chartArea.right, yPos);
									ctx.strokeStyle = 'rgba(255, 0, 0, 0.5)';
									ctx.lineWidth = 2;
									ctx.setLineDash([5, 5]);
									ctx.stroke();
									ctx.restore();
								}
							}
						}
					
					} ,
					
  
					responsive: true,
					scales: {
						y: {
							display: true,
							beginAtZero: false,
							suggestedMax: 8000000,
							suggestedMin: 500000,
							grid: {
								display: false,
								drawBorder: false,
								drawOnChartArea: true,
								drawTicks: false,
							},
						},
						x: {
							display: true,
							type: "category",
							ticks: {
								autoSkip: false, // Ensure no labels are skipped
								maxRotation: 0,  // Keep labels horizontal
								minRotation: 0,  // Prevent label rotation
								font: {
									size: function(context) {
										// Adjust font size based on the canvas width
										return context.chart.width < 600 ? 10 : 12;
									}
								},
								callback: function (value) {
									// Modify labels to display only those that end with "/3"
									if (value.endsWith("/3")) {
										return value.split("/")[0]; // Show only the year part
									}
									return ""; // Return empty string for labels that don't match
								},
							},
							grid: {
								display: false,
								drawBorder: false,
								drawTicks: false,
							},
						},
						xAxes: [
							{
								ticks: {
									autoSkip: false, // Ensure no labels are skipped
									maxRotation: 0,  // Keep labels horizontal
									minRotation: 0,  // Prevent label rotation
									font: {
										size: function(context) {
											// Adjust font size based on the canvas width
											return context.chart.width < 600 ? 10 : 12;
										}
									},
									callback: function (value) {
										if (value.endsWith("/3")) {
											return value.split("/")[0];
										}
										return "";
									},
								},
							},
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: false,
									callback: function (value) {
										// check from queryParam if page=deals or page=rent from url!!!
										const urlParams = new URLSearchParams(window.location.search);
										const page = urlParams.get("page");
										if (page == "deals") {			
											value =  ((value / 1000000).toFixed(2)).replace(".00", "").replace(".0", "");
											if (( value.endsWith("0")    &&  value.includes(".")   )){
												return value.slice(0, -1)  + " מ' ₪";
											}
											return value  + " מ' ₪";
										} else if (page == "rent") {
											// if desktop
											if (window.innerWidth > 600) {
											return ((value.toLocaleString() )).replace(".00", "").replace(".0", "") + " ₪";
											}
											else{
												value =  ((value / 1000).toFixed(2).toLocaleString()).replace(".00", "").replace(".0", "");
												if (( value.endsWith("0")    &&  value.includes(".")   )){
													return value.slice(0, -1)  + " א' ₪";
												}
												return value   + " א' ₪";
											}
										} else {
											return value;
										}
									},
								},
							},
						],
					},
				},
				//end chartOptions
			};
		},
		computed: {
			myChart(){
				return this.$store.state.myChart;
			},
			allData(){
				return this.$store.state.allData;
			},
			graphData() {
				return this.$store.state.graphData;
			},
			mapStatus() {
				return this.$store.state.mapStatus;
			},
		},
		watch: {
			mapStatus() {
				setTimeout(() => {
					this.updateChart();
					this.updateGraphData();
					if (this.myChart) {
						this.myChart.update();
						this.myChart.resize();
					}
				}, 250);
			},
			currentTab() {
				this.updateChart();
				this.updateGraphData();
				this.showLastDataPoint();
				
			},
			graphData: {
				handler() {
					this.updateChart();
				},
				deep: true,
			},
		},
		created() {
			//this.initializeChart();
		},
		beforeMount() {
		// 	this.getPageInfo().then(() => {
		// 		var fetchType = null;
		// 		if (this.pageType === "deals") {
		// 			fetchType = "buy";
		// 		}
		// 		if (this.pageType === "rent") {
		// 			fetchType = "rent";
		// 		}

		// 		if (fetchType) {
		// 			const id =this.neighborhoodId ? this.neighborhoodId : this.settlementId;
		// 			const neigh_or_setl = this.neighborhoodId ? "neighborhood" : "settlement";
		// 			this.fetchData(
		// 				`${this.$store.state.config.s3_page_base}/${neigh_or_setl}/${fetchType}/${id}.json?t=${new Date().getTime()}`,
		// 				neigh_or_setl
		// 			)
		// 		}
		// 	});
		},
		mounted() {
			this.tooltipEl = document.getElementById("tooltip");
			// Add resize listener with error handling
			try {
				window.addEventListener('resize', this.resized);
			} catch (error) {
				console.error("Error adding resize listener:", error);
			}
		},
		methods: {
			resized(){
				if (this.myChart != null) {
					this.myChart.resize();
				}
			},
			createVerticalLinePlugin() {
				const component = this;
				return {
				id: 'verticalLine',
				beforeDraw: function(chart) {
					chart.ctx.clearRect(0, 0, chart.width, chart.height);
				},
				afterDraw: function(chart) {
					if (typeof component.$store.state.pointIndex !== 'undefined' && chart.lastActive && chart.lastActive.length > 0) {
					const meta = chart.getDatasetMeta(0);
					const yScale = chart.scales['y-axis-0'];
					
					if (meta && 
							meta.data && 
						meta.data[component.$store.state.graphData.length - 1 - component.$store.state.pointIndex] &&
						meta.data[component.$store.state.graphData.length - 1 - component.$store.state.pointIndex]._model) {
						
						const x = meta.data[component.$store.state.graphData.length - 1 - component.$store.state.pointIndex]._model.x;
						
						const ctx = chart.ctx;
						
						if (ctx && yScale && typeof x !== 'undefined') {
						ctx.save();
						ctx.beginPath();
						
						ctx.lineWidth = 1;
						ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)';
						//ctx.setLineDash([5, 5]);
						
						const xPos = Math.round(x) + 0.5;
						
						ctx.moveTo(xPos, yScale.top);
						ctx.lineTo(xPos, yScale.bottom);
						ctx.stroke();
						
						ctx.beginPath();
						ctx.restore();
						}
					}
					}
				}
				};
			},
			
			

			showLastDataPoint() {


				if (this.$store.state.graphData.length == 0) {
					return;
				}


				const settlementPrices = this.$store.state.graphData.map(
					(entry) => entry.settlementPrice,
				);
				const countryPrices = this.$store.state.graphData.map((entry) => entry.countryPrice);
				const neighborhoodPrices = this.$store.state.graphData.map(
					(entry) => entry.neighborhoodPrice,
				);
				const labels = this.$store.state.graphData.map(
					(entry) => `${entry.year}/${entry.month}`,
				);
				var lastIndex = 0;
				if (this.base_level == "neighborhood") {
					lastIndex = neighborhoodPrices
						.slice()
						.findIndex((price) => price > 0);
					if (!neighborhoodPrices.some((num) => num > 0)) {
						lastIndex = 1;
					}
				} else {
					lastIndex = settlementPrices.slice().findIndex((price) => price > 0);
					if (!settlementPrices.some((num) => num > 0)) {
						lastIndex = 1;
					}
				}
				
				this.updateTooltip(
					labels[lastIndex],
					settlementPrices[lastIndex],
					countryPrices[lastIndex],
					neighborhoodPrices[lastIndex],
				);
			},
			updateTooltip(label, settlementPrice, countryPrice, neighborhoodPrice) {
				// label example: 2024/6
				// convert in to: רבעון שני 2024
				// split to get '6'
				
				const month =  label.split("/")[1];
				const year = label.split("/")[0];
				const labelsDictionary = {
					'3': 'רבעון ראשון',
					'6': 'רבעון שני',
					'9': 'רבעון שלישי',
					'12': 'רבעון רביעי'
				};
				let innerHtml = `<h3>${labelsDictionary[month]} ${ year }</h3>`;
				var datasets = [
					// { label: 'מחיר יישוב', value: settlementPrice, color: 'grey' },
					{ label: "מחיר ארצי", value: countryPrice, color: "#000" },
					{
						label: "מחיר חציוני " + this.settlementName,
						value: settlementPrice,
						color: "grey",
					},
				];
				if (this.$store.state.base_level === "neighborhoodId") {
					datasets.push({
						label: "מחיר חציוני " + this.$store.state.neighborhoodName,
						value: neighborhoodPrice,
						color: "#056db3",
					});
				}

				// reverse the array
				datasets = datasets.reverse();

				datasets.forEach((dataset) => {
					let valueDisplay = null;
					// check from queryParam if page=deals or page=rent from url!!!
					const urlParams = new URLSearchParams(window.location.search);
					const page = urlParams.get("page");
					if (dataset.value != null) {
						if (page == 'deals'){
								valueDisplay = (dataset.value / 1000000).toFixed(2) + " מ' ₪";
							
						} else if (page == 'rent'){
							valueDisplay = dataset.value.toLocaleString() + " ₪";
						}
						else{
							valueDisplay = "לא ידוע";
						}
					}
					else {
						valueDisplay = "לא ידוע";
					}

					const style = `background:${dataset.color};border-color:${dataset.color};border-width:2px;`;
					const span = `<span style="display:inline-block;width:10px;height:10px;margin-left:5px;${style}"></span>`;
					innerHtml += `<p>${span}${dataset.label}: ${valueDisplay}</p>`;
				});

				if (isNaN(settlementPrice) || isNaN(countryPrice)) {
					innerHtml = `<h3>אין מידע</h3>`;
				}
				else{
					
					innerHtml += `<div style="margin-top: 10px; left: 1px;"><span style="font-size: 14px;">הנתונים מוצגים בהתאם לרבעון הנבחר בגרף</span></div>`
				}
				this.tooltipEl.innerHTML = innerHtml;
			},
			async getPageInfo() {
				if (!this.$store.state.config){
					await this.$store.dispatch("loadConfig");
				}	
				// const types = {
				// 	street: "street_id",
				// 	neighborhood: "neigh_id",
				// 	kparcel_all: "parcel_id",
				// 	address: "addr_id",
				// 	settlement: "setl_id",
				// 	street_rent: "street_id",
				// 	neighborhood_rent: "neigh_id",
				// 	kparcel_rent: "parcel_id",
				// 	address_rent: "addr_id",
				// 	settlement_rent: "setl_id",
				// };
				// const searchType = this.$route.query.view;
				// const code = this.$route.query.id;
				// const page = this.$route.query.page;
				// var api_base = this.$store.state.config.api_base;
				// const api_url = api_base + "/GetInfo";
				// const payload = {
				// 	base_name: types[searchType],
				// 	base_id: code,
				// };
				// const response = await fetch(api_url, {
				// 	method: "POST",
				// 	headers: {
				// 		"Content-Type": "application/json",
				// 	},
				// 	body: JSON.stringify(payload),
				// });
				// const data = await response.json();

				// this.settlementId = data.setl_id;
				// this.settlementName = data.setl_name;
				// this.neighborhoodId = data.neigh_id;
				// this.neighborhoodName = data.neigh_name;
				// this.base_level = data.base_level;
				// this.pageType = page;
			},

			validateGraphData() {
				// Ensure graph data is valid and has entries
				return this.$store.state.graphData && 
					this.$store.state.graphData.length > 0 && 
					this.$store.state.graphData.some(entry => 
						entry.settlementPrice > 0 || 
						entry.countryPrice > 0 || 
						entry.neighborhoodPrice > 0
					);
			},

			updateGraphData() {
				// console.log("updateGraphData"  , this.$parent.selectedTab);
				// console.log("updateGraphData"  ,  this.allData);
				this.currentTab = this.$parent.selectedTab;
				const roomData = this.allData.find(
					data => data.numRooms.toString() === this.currentTab
				);

				if (roomData && roomData.graphData) {
					
					this.$store.state.graphData = roomData.graphData;

					// Only update if valid data exists
					if (this.validateGraphData()) {
						// console.log("updateGraphData11111"  ,  this.$store.state.graphData);
						this.maxPrice = Math.max(
						...this.$store.state.graphData.map(entry => entry.settlementPrice),
						...this.$store.state.graphData.map(entry => entry.countryPrice),
						...this.$store.state.graphData.map(entry => entry.neighborhoodPrice)
						) * 1.1;

						this.minPrice = Math.min(
						...this.$store.state.graphData.map(entry => entry.settlementPrice),
						...this.$store.state.graphData.map(entry => entry.countryPrice),
						...this.$store.state.graphData.map(entry => entry.neighborhoodPrice)
						) * 0.9;
					} else {
						console.warn("Invalid graph data for tab:", this.currentTab);
					}
				}
			},

			async initializeChart() {
				try {
				// Ensure config is loaded
				if (!this.$store.state.config) {
					await this.$store.dispatch("loadConfig");
				}

				// Get page info
				//await this.getPageInfo();
				// Determine fetch type based on url param: page=deals or page=rent
				const urlParams = new URLSearchParams(window.location.search);
				this.pageType = urlParams.get("page");
				const fetchType = this.pageType === "deals" ? "buy" : 
									this.pageType === "rent" ? "rent" : null;
				if (fetchType) {
					const id = this.neighborhoodId || this.settlementId;
					const type = this.neighborhoodId ? "neighborhood" : "settlement";
					this.$nextTick(() => {
						this.fetchData(
						`${this.$store.state.config.s3_page_base}/${type}/${fetchType}/${id}.json?t=${Date.now()}`,
						type
						).then(() => {
							this.$nextTick(() => {
								const roomTabElement = document.getElementById('roomTab_all');
								if (roomTabElement) {
									roomTabElement.click();
								}
							});
						});
					});
				}
				} catch (error) {
				console.error("Chart initialization error:", error);
				// Implement error handling UI
				}
			},
			async fetchData(url, type) {
				try {
				const response = await fetch(url);
				const data = await response.json();
				// Ensure data is loaded before creating chart
				if (data && data.trends && data.trends.rooms) {
					this.$store.state.allData = data.trends.rooms;
					this.typePage = type;

					// Use nextTick to ensure DOM is ready
					this.$nextTick(() => {
						this.createChart();
						this.updateGraphData();
						this.showLastDataPoint();
					});
				} else {
					throw new Error("Invalid data structure");
				}
				} catch (error) {
				console.error("Data fetching error:", error);
				// Implement error handling UI
				}
			},
			createChart() {
				// Add additional safety checks
				const myChartCanvas = this.$refs.myChart || document.getElementById("myChart");
				
				if (!myChartCanvas) {
				console.error("Chart canvas not found");
					return;
				}

				// Destroy existing chart if it exists
				if (this.$store.state.myChart) {
					this.$store.state.myChart.destroy();
				}
				try {
					const data = this.formatChartData();
					this.$store.state.myChart = new Chart(myChartCanvas, {
						type: "line",
						data: data,
						options: this.chartOptions,
						plugins: [this.createVerticalLinePlugin()]
					});
				} catch (error) {
					console.error("Chart creation error:", error);
				}
			},
			updateChart() {
				const data = this.formatChartData();
				if (!this.myChart) {
					return;
				}
				this.myChart.data.labels = data.labels;
				this.myChart.data.datasets = data.datasets;
				this.myChart.options = this.chartOptions;
				
				this.myChart.plugins = [this.createVerticalLinePlugin()];
				this.myChart.update();

				this.showLastDataPoint();
			},
			formatChartData() {
				const labels = this.$store.state.graphData
					.map((entry) => `${entry.year}/${entry.month}`)
					.reverse();
				const neighborhoodPrices = this.$store.state.graphData
					.map((entry) => entry.neighborhoodPrice)
					.reverse();
				const settlementPrices = this.$store.state.graphData
					.map((entry) => entry.settlementPrice)
					.reverse();
				const countryPrices = this.$store.state.graphData
					.map((entry) => entry.countryPrice)
					.reverse();
				return {
					labels: labels,
					datasets: [
						{
							label: "מחיר בשכונה",
							data: neighborhoodPrices,
							fill: false,
							backgroundColor: "#056db3",
							borderColor: "#056db3",
							borderWidth: 1,
							pointRadius: 2,
							tension: 0.3,
						},
						{
							label: "מחיר בישוב",
							data: settlementPrices,
							fill: false,
							backgroundColor: "grey",
							borderColor: "grey",
							borderWidth: 1,
							pointRadius: 2,
							tension: 0.3,
						},
						{
							label: "מחיר בארץ",
							data: countryPrices,
							fill: false,
							backgroundColor: "#000",
							borderColor: "#000",
							borderWidth: 1,
							pointRadius: 2,
							tension: 0.3,
						},
					],
				};
			},
		},
	};
</script>

<style>
	.graph {
		width: 100%;
		max-width: 80%;
		margin: 0 auto;
		min-width: 600px;
	}
	.tabs1 {
		display: flex;
		justify-content: center;
		margin-bottom: 20px;
	}
	.tabs1 button {
		background-color: #f0f0f0;
		border: none;
		padding: 10px 20px;
		margin: 0 5px;
		cursor: pointer;
	}
	.tabs1 button.active {
		background-color: #ddd;
	}
	#tooltip1 {
		background-color: rgba(255, 255, 255, 0.9);
		border: 1px solid #ddd;
		border-radius: 8px;
		padding: 10px;
		font-size: 10px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		margin: 15px;
		height: 120px;
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		justify-content: space-evenly;
		user-select: none;
	}
</style>
